import { tStr } from './Util';

const  MT_TEMP		= 0
const  MT_HUMIDITY	= 1
const  MT_WIND_SPEED	= 2
const  MT_WIND_DIR	= 3
const  MT_RAIN		= 4
// const  MT_MAX_RAIN	= 5
// const  MT_PRESS	= 6
// const  MT_WEATHER	= 7

const  MT_SEA_TEMP	= 8
const  MT_SEA_LEVEL	= 9

const  MT_MODAL_WDI	= 10
// const  MT_TWATER	= 11
// const  MT_WTP	= 12
// const  MT_WHDD	= 13
const  MT_WAVEHS	= 14

// const  N_MEAS	= 15


function getDirArrow(angle) {
	angle = angle % 360;

	if (angle < 22.5 || angle > 360 - 22.5) {
		return '↓';
	} else if (angle < 45 + 22.5) {
		return '↙';
	} else if (angle < 90 + 22.5) {
		return '←';
	} else if (angle < 135 + 22.5) {
		return '↖';
	} else if (angle < 180 + 22.5) {
		return '↑';
	} else if (angle < 225 + 22.5) {
		return '↗';
	} else if (angle < 270 + 22.5) {
		return '→';
	}

	return '↘';
}

export function getAutostationWeather(station) {
	let m, str;
	
	str = '';

	m = station.meas.find(item => item.meas_type === MT_TEMP);
	if (m) {
		if (str.length)
			str += ', '

		str += m.value + m.unit;
	}

	m = station.meas.find(item => item.meas_type === MT_WIND_SPEED);
	if (m) {
		if (str.length)
			str += ', '

		str += m.value + ' ' + m.unit;

		m = station.meas.find(item => item.meas_type === MT_WIND_DIR);
		if (m) {
			str += ' ' + getDirArrow(m.value);
		}
	}

	m = station.meas.find(item => item.meas_type === MT_HUMIDITY);
	if (m) {
		if (str.length)
			str += ', '

		str += m.value + m.unit;
	}
	
	m = station.meas.find(item => item.meas_type === MT_RAIN)
	if (m) {
		if (str.length)
			str += ', '

		str += m.value + ' ' + m.unit;
	}

	return str;
}

export function getMareographWeather(station) {
	let m, str;

	str = '';

	m = station.meas.find(item => item.meas_type === MT_SEA_TEMP);
	if (m) {
		if (str.length)
			str += ', '

		str += m.value + m.unit;
	}

	m = station.meas.find(item => item.meas_type === MT_SEA_LEVEL);
	if (m) {
		let wl = Math.round(m.value / 10.0);

		if (str.length)
			str += ', '

		str += (wl <= 0 ? '-' : '+') + wl;
	}

	return str;
}

export function getWavebuoyWeather(station) {
	let m, str;

	str = '';

	m = station.meas.find(item => item.meas_type === MT_WAVEHS);
	if (m) {
		str += m.value + ' ' + m.unit;
	
		m = station.meas.find(item => item.meas_type === MT_MODAL_WDI);
		if (m) {
			str += ' ' + getDirArrow(m.value);
		}
	}

	return str;
}

export function getSunStr(sun) {
	let str = '☀';
	
	if (sun.altitude > 0) {
		str += getDirArrow(sun.azimuth) + ' ' + Math.round(sun.altitude) + '°';
	} else {
		str += ' -';
	}

	if (sun.rise && sun.set)
		str += ', ' + tStr(sun.rise) + '-' + tStr(sun.set);

	return str;
}
